import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../constants';

@Injectable()
export class AttachmentsenderService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	// getAttachmentsByProposalLayout(proposalLayout) {
	// 	return this.http
	// 	.get(this.apiUrl + "documents/v1/getbylayout/" + proposalLayout, JSON.parse(localStorage.getItem('yara.connectionHeader')))
	// 	.map((res: Response) => res.json()).catch(e => {
	// 		if (e.status === 401) {
	// 			return Observable.throw('Unauthorized');
	// 		}
	// 	});
	// }
	  
	getAttachmentsByProposalLayout(data) {
		return this.http
			.post(this.apiUrl + "documents/v1/getbylayout", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAttachmentByProposal(proposalID) {
		return this.http
			.get(this.apiUrl + "attachment/v1/getattachmentbyproposal/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAttachmentsByProposalFromProposal(token, id) {
		return this.http
			.get(this.apiUrl + "attachment/v1/getlistattachmentbyproposalid/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveAttachment(token, data) {
		console.log("teste", data);
		return this.http
			.post(this.apiUrl + "attachment/v1/uploadattachment", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	downloadAttachment(id) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "attachment/v1/downloadattachment/" + id, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	inactivateAttachment(id) {
		return this.http
			.delete(this.apiUrl + "attachment/v1/inactiveattachment/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	getFileSize(token) {
		return this.http
			.get(this.apiUrl + "system/v1/getcodparameterstype/tamanho", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getFileType(token) {
		return this.http
			.get(this.apiUrl + "system/v1/getcodparameterstype/anexo", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
	
	searchAttachment(token, descricao, status, orderby, sort, page) {

		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;

		page = page * globalConst.paginationSkip;

		return this.http
			.get(this.apiUrl + "documents/v1/getattachment?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "&$filter=startswith(tolower(Descricao),'" + descricao.toLowerCase() + "') " + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
	
	searchAttachmentByCategory(token, CategoriaDocumento, status, orderby, sort, page) {
        var statusFilter = "";
        if (status != "") statusFilter = "and Ativo eq " + status;
        return this.http
            .get(this.apiUrl + "documents/v1/getattachment?$orderby=" + orderby + " " + sort + "&$filter=CategoriaDocumento eq " + Number(CategoriaDocumento)+ "" + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
            .map((res: Response) => res.json()).catch(e => {
                if (e.status === 401) {
                    return Observable.throw('Unauthorized');
                }
            });
    }

}





// WEBPACK FOOTER //
// ./src/app/attachmentsender/service/attachmentsender.service.ts